module.exports = __webpack_public_path__ + "img/ic_bed_sandh_1.76749da0.png";